/* Browser tab behaviour — notes in theme/tab-icon.md (department folder).
   Visible: the 9 (gold, or gold-on-dark in dark mode); on a product page, the print in a thin gold frame.
   Cart has items: a small oxblood dot on the icon. Hidden: a gentle title, and the icon swaps between the 9
   and the print every 2 s (background tabs are throttled to ~1/s; Safari ignores icon changes, titles still work). */
(function () {
  var cfgEl = document.getElementById('nine-tab-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var SIZE = 64, GOLD = '#d3af37', DOT = '#7b1f27';
  var darkQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
  var count = cfg.count || 0, title = document.title, timer = null, frame = 0;
  var imgs = {}, cache = {};

  function load(key, src) {
    return new Promise(function (resolve) {
      if (!src) return resolve(null);
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { imgs[key] = im; resolve(im); };
      im.onerror = function () { resolve(null); };
      im.src = src.indexOf('//') === 0 ? location.protocol + src : src;
    });
  }

  function isDark() { return !!(darkQuery && darkQuery.matches); }

  // kind: 'nine' or 'art'
  function draw(kind) {
    var dot = count > 0, key = kind + (kind === 'nine' && isDark() ? '-dark' : '') + (dot ? '-dot' : '');
    if (cache[key]) return cache[key];
    var c = document.createElement('canvas'); c.width = c.height = SIZE;
    var x = c.getContext('2d'), bg;
    if (kind === 'art' && imgs.art) {
      var im = imgs.art, s = Math.min(im.width, im.height);
      var sx = (im.width - s) / 2, sy = (im.height - s) * 0.3;          // portrait: keep the upper part (faces)
      x.fillStyle = GOLD; x.fillRect(0, 0, SIZE, SIZE);                  // thin gold frame
      x.drawImage(im, sx, sy, s, s, 5, 5, SIZE - 10, SIZE - 10);
      bg = GOLD;
    } else {
      var base = isDark() ? imgs.dark : imgs.light;
      if (!base) return null;
      x.drawImage(base, 0, 0, SIZE, SIZE);
      bg = isDark() ? '#181614' : GOLD;
    }
    if (dot) {
      x.beginPath(); x.arc(SIZE - 13, 13, 13, 0, 2 * Math.PI); x.fillStyle = bg; x.fill();
      x.beginPath(); x.arc(SIZE - 13, 13, 10, 0, 2 * Math.PI); x.fillStyle = DOT; x.fill();
    }
    try { cache[key] = c.toDataURL('image/png'); } catch (e) { cache[key] = null; }   // tainted canvas: skip
    return cache[key];
  }

  var link;
  function setIcon(href) {
    if (!href) return;
    if (!link) {
      document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]').forEach(function (l) { l.remove(); });
      link = document.createElement('link'); link.rel = 'icon'; link.type = 'image/png';
      document.head.appendChild(link);
    }
    if (link.href !== href) link.href = href;
  }

  function awayTitle() {
    if (count > 0) return count > 1 ? cfg.cartMany : cfg.cartOne;
    return cfg.away || '';
  }

  function render() {
    if (document.hidden) {
      var t = awayTitle(); if (t) document.title = t;
      var showArt = imgs.art && frame % 2 === 1;
      setIcon(draw(showArt ? 'art' : 'nine'));
    } else {
      document.title = title;
      setIcon(draw(cfg.artIsIcon && imgs.art ? 'art' : 'nine'));
    }
  }

  function onVisibility() {
    clearInterval(timer); timer = null; frame = 0;
    if (document.hidden) {
      if (!cfg.artIsIcon) frame = 1;   // product tab already shows the print: start the swap on the 9
      if (imgs.art) timer = setInterval(function () { frame++; render(); }, 2000);
    } else {
      title = document.title === awayTitle() ? title : document.title;
    }
    render();
  }

  function setCount(n) {
    if (typeof n !== 'number' || n === count) return;
    count = n; cache = {}; render();
  }

  Promise.all([load('light', cfg.light), load('dark', cfg.dark), load('art', cfg.art)]).then(function () {
    render();
    document.addEventListener('visibilitychange', onVisibility);
    if (darkQuery && darkQuery.addEventListener) darkQuery.addEventListener('change', function () { render(); });
    document.addEventListener('cart:change', function (e) {
      if (e.detail && e.detail.cart) setCount(e.detail.cart.item_count);
    });
    var refresh = function () {
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js')
        .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
    };
    document.addEventListener('cart:refresh', refresh);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  });
})();
